import { createPortal } from 'react-dom';
import './print-view.styles.scss';

export const PrintView = ({ children }) => {
  return (
    <>
      {children}
      {createPortal(
        <div className="print-view">{children}</div>,
        document.body,
      )}
    </>
  );
};
